import { Injectable } from '@angular/core';
import {Bookmarks} from "../models/Misc/Bookmarks";
import {SynapiItem} from "../models/Synapi/SynapiItem";
import {SynapiItemTypes} from "../models/Synapi/enums/SynapiItemTypes";
import {BehaviorSubject} from "rxjs";
import {WordpressService} from "./wordpress.service";

@Injectable({
  providedIn: 'root'
})
export class BookmarksService {
  bookmarks = new Bookmarks();
  bookmarks$ = new BehaviorSubject<Bookmarks>(new Bookmarks());
  constructor(public wordpressService: WordpressService) {
    if(typeof localStorage !== "undefined"){
      this.load();
    }
  }

  load(){
    const json = localStorage.getItem("bookmarks");
    if(json){
      this.bookmarks = Bookmarks.fromJson(json);
      this.bookmarks$.next(this.bookmarks);
    }
  }

  save(){
    localStorage.setItem("bookmarks", this.bookmarks.toJson());
  }

  set(bookmarks: Bookmarks){
    this.bookmarks = bookmarks;
    this.bookmarks$.next(this.bookmarks);
  }

  add(item : SynapiItem){
    const t = SynapiItemTypes;
    switch(item.TypeFiche){
      case t.ACTIVITE:
      case t.PATRIMOINE_CULTUREL:
      case t.PATRIMOINE_NATUREL:
        this.bookmarks.activities.push(item.ExternalId);
        break;
      case t.RESTAURATION:
      case t.DEGUSTATION:
        this.bookmarks.restaurants.push(item.ExternalId);
        break;
      case t.HEBERGEMENT_COLLECTIF:
      case t.HEBERGEMENT_LOCATIF:
      case t.HOTELLERIE:
      case t.HOTELLERIE_PLEIN_AIR:
        this.bookmarks.accommodations.push(item.ExternalId);
        break;
      case t.FETE_ET_MANIFESTATION:
        this.bookmarks.events.push(item.ExternalId);
        break;
      case t.COMMERCE_ET_SERVICE:
        this.bookmarks.services.push(item.ExternalId);
        break;
      case t.SEJOUR_PACKAGE:
        this.bookmarks.stays.push(item.ExternalId);
        break;
      default:
        this.bookmarks.others.push(item.ExternalId);
    }
    this.bookmarks$.next(this.bookmarks);
  }

  count(){
    let count = 0;
    count += this.bookmarks.activities.length;
    count += this.bookmarks.restaurants.length;
    count += this.bookmarks.accommodations.length;
    count += this.bookmarks.events.length;
    count += this.bookmarks.services.length;
    count += this.bookmarks.stays.length;
    count += this.bookmarks.others.length;
    return count;
  }

  remove(item : SynapiItem){
    for (const [key, value] of Object.entries(this.bookmarks)) {
      // @ts-ignore
      this.bookmarks[key] = (this.bookmarks[key] as string[]).filter((e)=> item.ExternalId !== e);
    }
    this.bookmarks$.next(this.bookmarks);
  }

  removeAll(){
    for (const [key, value] of Object.entries(this.bookmarks)) {
      // @ts-ignore
      this.bookmarks[key] = [];
    }
    this.bookmarks$.next(this.bookmarks);
    this.save();
  }

  has(item : SynapiItem){
    for (const [key, value] of Object.entries(this.bookmarks)) {
      // @ts-ignore
      if((this.bookmarks[key] as string[]).indexOf(item.ExternalId) > -1){
        return true;
      }
    }
    return false;
  }

  toggle(item : SynapiItem){
    if(this.has(item)){
      this.remove(item);
    } else {
      this.add(item);
    }
    this.bookmarks$.next(this.bookmarks);
    this.save();
  }

  extractIds(){
    let ids: string[] = [];
    for (const [key, value] of Object.entries(this.bookmarks)) {
      // @ts-ignore
      ids = ids.concat(this.bookmarks[key])
    }
    return ids;
  }

  pdf(){
    const ids = this.extractIds();
    if(ids.length>0){
      this.wordpressService.getSynapiPdf(true,ids, false).then((url)=>{
        var w = window.open(url,'_blank');
        if(w){
          try {
            w.focus();
          } catch (e) {
            alert("Votre navigateur bloque actuellement l'ouverture de votre fichier à imprimer.");
          }
        }
      });
    }
  }
}
